import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Modal, Button, Alert } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';
import Login from './../shared/Login';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyServicesBook } from './../../../actions';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

import isNil from 'lodash/isNil';
import find from 'lodash/find';

const bwCoreLogo = require('./../../../images/bwcore_logo.png');
const bwMainLogo = require('./../../../images/bwmain_logo.png');
const bwPlusLogo = require('./../../../images/bwplus_logo.png');
const bwPremierLogo = require('./../../../images/bwpremier_logo.png');
const bwPremierCollectionLogo = require('./../../../images/bwpremiercollection_logo.png');
const bwSignatureCollectionLogo = require('./../../../images/bwsignaturecollection_logo.png');
const bwSureHotelCollectionLogo = require('./../../../images/bwsurehotelcollection_logo.png');
const whDistinctiveLogo = require('./../../../images/whdistinctive_logo.png')
const bwAidenLogo = require('./../../../images/bwaiden_logo.png')
const whCraftedLogo = require('./../../../images/whcrafted_logo.png')
const whEliteLogo = require('./../../../images/whelite_logo.png')

import './servicemodal.scss';

class ServiceModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      bookError: false
    };

    this.handleBookButton = this.handleBookButton.bind(this);
    this.handleOnEnter = this.handleOnEnter.bind(this);
    this.handlePhoneClick = this.handlePhoneClick.bind(this);
  }

  /* Methods */

  getLogo() {
    let logo;
    switch (this.props.hotel.template) {
      case 'BWCore':
        logo = bwCoreLogo
        break;
      case 'BWMain':
        logo = bwMainLogo
        break;
      case 'BWPlus':
        logo = bwPlusLogo
        break;
      case 'BWPremier':
        logo = bwPremierLogo
        break;
      case 'BWPremierCollection':
        logo = bwPremierCollectionLogo
        break;
      case 'BWSignatureCollection':
        logo = bwSignatureCollectionLogo
        break;
      case 'BWSureHotelCollection':
        logo = bwSureHotelCollectionLogo
        break;
      case 'WHDistinctive':
        logo = whDistinctiveLogo
        break;
      case 'BWAiden':
        logo = bwAidenLogo;
        break;
      case 'WHCrafted':
        logo = whCraftedLogo;
        break;
      case 'WHElite':
        logo = whEliteLogo;
        break;
      default:
        logo = bwCoreLogo
        break;
    }
    return logo;
  }

  /* Handlers */

  handleBookButton() {
    this.props.actions.customerJourneyServicesBook(
      this.props.id,
      this.props.token,
      this.props.currentLanguage,
      (data) => {
        ReactGA.event({
          category: 'Service Book', // TODO Invertito ai fini del test
          value: this.props.price,
          action: this.props.currentCategoryName,
          label: this.props.name
        });
        ReactGA4.event({
          category: this.props.currentCategoryName,
          value: this.props.price,
          action: 'Service Book',
          label: this.props.name
        });
        this.props.onHide();
      },
      () => {
        this.setState({bookError: true})
      });
  }

  handleOnEnter() {
    this.setState({bookError: false})
  }

  handlePhoneClick() {
    ReactGA.event({
      category: 'Phone number',
      value: this.props.hotel.phone,
      action: 'Phone number clicked',
      label: this.props.hotel.id
    });
    ReactGA4.event({
      category: 'Phone number clicked', // TODO Invertito ai fini del test
      value: this.props.hotel.phone,
      action: 'Phone number',
      label: this.props.hotel.id
    });
  }

  /* Lifecycle */

  render() {

    const bookButton = (
      <Button bsStyle="primary" className="customize-servicemodal-component__book-button center-block" onClick={this.handleBookButton}>
        <strong>{this.props.translate('customize.service_modal.book_now_button')}</strong>
      </Button>);

    const pendingServiceWarningMessage = (
      <div>
        <Alert bsStyle="warning" className="text-center">
          <p>{this.props.translate('customize.service_modal.pending_service_warning_message', {service: (this.props.bookingPendingService || {}).name})}</p>
        </Alert>
      </div>
    );

    const bookErrorMessage = (
      <div>
        <Alert bsStyle="danger" className="text-center">
          <p>{this.props.translate('customize.service_modal.book_error_message')}</p>
          <br/>
          <Button className="center-block" onClick={this.props.onHide}>{this.props.translate('customize.service_modal.close_button')}</Button>
        </Alert>
      </div>
    );

    let servicePrice = `${this.props.price} ${this.props.currency} ${this.props.payment_type}`;
    let freeService = false;
    switch (isNil(this.props.price) || isNaN(this.props.price) || parseFloat(this.props.price)) {
      case true:
        servicePrice = null;
        break;
      case 0:
        servicePrice = this.props.translate('customize.service_card.free');
        freeService = true;
        break;
    }

    const style = { backgroundImage: `url(${this.props.picture})` };

    const serviceModalContent = (
      <div>
        <Modal.Header style={style}>
          <button className='customize-servicemodal-component__close-button' onClick={this.props.onHide}><i className="fa fa-times"/></button>
          <Modal.Title className="customize-servicemodal-component__title" componentClass={'h3'}><strong>{this.props.name}</strong></Modal.Title>
          <h5 className="customize-servicemodal-component__sub-title"><strong className={freeService ? 'text-success' : null}>{servicePrice}</strong></h5>
        </Modal.Header>
        <Modal.Body>
          <p>{this.props.description}</p>
        </Modal.Body>
        <Modal.Footer>
          <LoadingPlaceholder ready={!this.props.bookingLoading} text-align="center">
            { !!this.props.bookingPendingService ? pendingServiceWarningMessage : ( this.state.bookError ? bookErrorMessage : bookButton ) }
          </LoadingPlaceholder>
        </Modal.Footer>
      </div>
    );

    const loginModalContent = (
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <button className='customize-servicemodal-component__close-button' onClick={this.props.onHide}><i className="fa fa-times"/></button>
            <h3 className="text-center"><strong>{this.props.translate('customize.service_modal.your_login')}</strong></h3>
            <br/>
            <br/>
          </Col>
        </Row>
        <Row className="customize-servicemodal-component__login-wrap-row">
          <Col xs={12} sm={6} smOffset={3} className="customize-servicemodal-component__login-wrap">
            <Login/>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="text-center">
            <br/>
            <p>{this.props.translate('customize.service_modal.login_text')}</p>
            <p>{this.props.translate('customize.service_modal.call_reception')}</p>



            <h4 className="hidden-xs hidden-sm"><i className="fa fa-phone"></i> <a href={`tel:${this.props.hotel.phone}`} onClick={this.handlePhoneClick}>{this.props.hotel.phone}</a></h4>
            <div className="hidden-md hidden-lg">
              <Button href={`tel:${this.props.hotel.phone}`} onClick={this.handlePhoneClick}>
                <i className="fa fa-phone"></i> {this.props.hotel.phone}
              </Button>
            </div>

            <br/>
            <p>
              <img className="customize-servicemodal-component__logo" src={this.getLogo()} alt="Best Western" />
            </p>
          </Col>
        </Row>
      </Modal.Body>
    );

    return (
      <Modal className="customize-servicemodal-component" show={this.props.show} onEnter={this.handleOnEnter}>
        {!!this.props.context || this.props.hotel.customer_journey_status != 'active' ? loginModalContent : serviceModalContent}
      </Modal>
    );
  }
}

ServiceModal.displayName = 'PagesCustomizeServiceModal';
ServiceModal.propTypes = {};
ServiceModal.defaultProps = {};

const mapStateToProps = (state, ownProps) => {

  return {
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      hotel: state.hotel.apiData,
      bookingLoading: state.services.bookingLoading,
      bookingPendingService: find(state.services.apiData, ['status', 'wait_response']),
      // currentCategoryId: state.services.catId,
      currentCategoryName: (find(state.categories.apiData, ['id', state.services.catId]) || {}).name
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyServicesBook: bindActionCreators(customerJourneyServicesBook, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceModal);



// WEBPACK FOOTER //
// ./components/pages/customize/ServiceModal.js